import { isEmpty } from "../../../library/Core/SmartFunctions";

const KeyCloakStudentSelectionLayout = (data: any) => {
    const { handleSelection,studentsLength,studentData } = data;

    const schoolDataLocalStorage = localStorage.getItem('school_settings');
    const schoolSettings = schoolDataLocalStorage ? JSON.parse(schoolDataLocalStorage) : {'domain': 'vibgyor'};
    let domain = schoolSettings?.domain;

    return (
        <>
          
            <div className="main flex-1">
                <div className="bg-purple alumni-networks-header">
                    <div className="max-1140 mx-auto py-5">
                        {studentsLength > 0 && <div className="pt-4 d-flex flex-column align-items-center text-center">
                            <h1>The account is associated<br/>with {studentsLength} User</h1>
                            {(studentsLength > 0) && (<p>Select the Student for which you wish to access the information! </p>)}
                        </div>}

                        {studentsLength === 0 && <div className="pt-4 d-flex flex-column align-items-center text-center">
                            <h1>Access is currently unavailable. To avail the benefits of the VIBGYOR Alumni Association (VAA), parents may opt for the alumni fees through the Fees section of the app</h1>
                        </div>}
                    </div>
                </div>
                <div className="alumni-networks-block-wrap pb-5">
                    <div className="max-1140 mx-auto position-relative">
                        <div className="row g-4 justify-content-center">
                         {studentData
                             .map((student: any) => (
                            <div key={student.id} className={`col-md-4 col-sm-6`}>
                                <div className="alumni-networks-block">
                                    <img src={isEmpty(student.profile_picture_file_path) ? 'https://ags-images-bucket.s3.ap-south-1.amazonaws.com/images/yellow-student-boy.svg' : student.profile_picture_file_path} width="200" className="img-fluid" alt="" />
                                    <h4>{student.first_name.charAt(0).toUpperCase() + student.first_name.slice(1)} {student.last_name.charAt(0).toUpperCase() + student.last_name.slice(1)}</h4>
                                    <button className="btn btn-green" onClick={() => handleSelection(student.id)}>
                                    <span>Enter</span>
                                    </button>
                                </div>
                            </div>
                        ))}
                        </div>

                        {studentsLength == 0 && (
                            <div className="position-absolute top-50 start-50 translate-middle">
                                <a href={`${process.env.REACT_APP_APP_BASE_URL}/user/${domain}/login`} className="btn btn-green">
                                    <span>Back to Login Page</span>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
                
            </div>
        </>
    );
};

export default KeyCloakStudentSelectionLayout;
